import React from 'react';
import hitakrilogo from '../../assets/img/hitakrilogo.png';

const Footer = () => {
    return (
        <footer className="footer">
            {/* Footer Top */}
            <div className="footer-top">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-about">
                                <div className="footer-logo">
                                    <img src={hitakrilogo} alt="Hitkari Hospital Logo" className="footer-logo-img" style={{ backgroundColor: '#4b8cd681' }} />
                                </div>
                                <div className="footer-about-content">
                                    <p>Your health is our priority. Combining advanced care with a personal touch, our expert team is dedicated to supporting your journey to better health.</p>
                                    <div className="social-icon">
                                        <ul> <li>
                                            <a href="https://in.linkedin.com/in/hitkari-hospital-1890ab207" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-linkedin"></i> 
                    </a></li>
                                            <li><a href="https://www.facebook.com/p/Hitkari-Hospital-100063931666732/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a></li>
                                            <li><a href="https://www.instagram.com/hitkarihospital/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title"></h2>
                                <ul>
                                    <li><a href="/listdoctor"><i className="fas fa-angle-double-right"></i> Search for Doctors</a></li>
                                    <li><a href="/privacypolicy"><i className="fas fa-angle-double-right"></i> Privacy-Policy</a></li>
                                    <li><a href="/terms"><i className="fas fa-angle-double-right"></i> Terms-Conditions</a></li>
                                    <li><a href="/appointments"><i className="fas fa-angle-double-right"></i> Booking</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                            <h2 className="footer-title"
                                >
                                   
                                </h2>
                                <ul>
                                    <li><a href="/appointments"><i className="fas fa-angle-double-right"></i> Appointments</a></li>
                                    <li><a href="/gallery"><i className="fas fa-angle-double-right"></i> Gallery</a></li>
                                    <li><a href="/services"><i className="fas fa-angle-double-right"></i> Services</a></li>
                                    <li><a href="/blogs"><i className="fas fa-angle-double-right"></i> Blogs</a></li>
                                     <li><a href="/carrer"><i className="fas fa-angle-double-right"></i> Carrer</a></li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-contact">
                                <h2 className="footer-title">Contact Us</h2>
                                <div className="footer-contact-info" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                    <div className="footer-address" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <a href="https://www.google.com/maps?q=NEAR+MTM+SCHOOL,+BALOTRA" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', textDecoration: 'none', color: 'inherit', alignItems: 'flex-start' }}>
                                            <i className="fas fa-map-marker-alt" style={{ marginRight: '5px' }}></i>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <span>Neelam Cinema Ke Pass, BALOTRA,</span>
                                                <span>DISTT.- BARMER ( RAJASTHAN ),</span>
                                                <span>PIN – 344022</span>
                                            </div>
                                        </a>
                                    </div>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="tel:7378125151" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit',marginTop:'18px' }}>
                                            <i className="fas fa fa-phone" style={{ marginRight: '5px' }}></i>
                                            +91 7378125151
                                        </a>
                                    </p>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="mailto: contact@hitkarihospital.com" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit', marginTop:'18px' }}>
                                            <i className="fas fa-envelope" style={{ marginRight: '5px' }}></i>
                                            contact@hitkarihospital.com
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container-fluid">
                    <div className="copyright">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="copyright-text">
                                    <p className="mb-0">
                                        <a href="/" style={{ color: 'white', textDecoration: 'none' }}>@ Copyright Hitkari Hospital, All rights reserved.</a>
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="copyright-menu">
                                    <ul className="policy-menu">
                                        <li><a href="https://dheersoftwaresolutions.com/" style={{ color: 'white', textDecoration: 'underline', marginRight:'132px',display:"none" }} target="_blank" rel="noopener noreferrer">Developed By ,Dheer Software Solutions</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;